import { de } from './de'
import { en } from './en'

export const locale: { de: typeof de; en: typeof en } = { de, en }
